import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DropdownItem} from '@shared/models/shared.models';

@Component({
    selector: 'app-categories-dropdown',
    templateUrl: './categories-dropdown.component.html',
    styleUrls: ['./categories-dropdown.component.scss'],
    standalone: false
})
export class CategoriesDropdownComponent implements OnInit {
  @Input() selectedItem = 'Search All';
  @Input() categories: DropdownItem[];

  @Output()
  changePaginationOptions: EventEmitter<string> = new EventEmitter<string>();

  isOpened = false;

  ngOnInit(): void {
    // Comment needed for Sonar
  }

  onSelectItem(item: any) {
    if (item.name !== this.selectedItem) {
      this.changePaginationOptions.emit(item.id);
    }
  }

  changeDropdownStatus() {
    this.isOpened = !this.isOpened;
  }

  closeDropdown() {
    this.isOpened = false;
  }
}
